import { createSlice } from "@reduxjs/toolkit";
import {
    fetchGPATableColumnNames,
    fetchAllGPA,
    createGPA,
    updateGPA,
    deleteGPA,
    activateDeactivateGPA
} from "./thunk";
import { toast } from "react-toastify";

const GPASlice = createSlice({
  name: "GPA",
  initialState: {
    gpa: [],
    tableColumnNames: [],
    loading: false,
    Headerload: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder

      // Fetch Question Type Table Column Names
      .addCase(fetchGPATableColumnNames.pending, (state) => {
        state.Headerload = true;
        state.error = null;
      })
      .addCase(fetchGPATableColumnNames.fulfilled, (state, action) => {
        state.Headerload = false;
        state.tableColumnNames = action.payload;
      })
      .addCase(fetchGPATableColumnNames.rejected, (state, action) => {
        state.Headerload = false;
        state.error = action.payload;
      })

      // Get All Question Type
      .addCase(fetchAllGPA.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllGPA.fulfilled, (state, action) => {
        state.loading = false;
        state.gpa = action.payload;
      })
      .addCase(fetchAllGPA.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Add Question Type
      .addCase(createGPA.pending, (state) => {
        state.error = null;
      })
      .addCase(createGPA.fulfilled, (state, action) => {
        state.gpa = [action.payload.data[0], ...state.gpa];
      })
      .addCase(createGPA.rejected, (state, action) => {
        state.error = action.payload;
      })

      // Update Question Type
      .addCase(updateGPA.pending, (state) => {
        state.error = null;
      })
      .addCase(updateGPA.fulfilled, (state, action) => {
        const index = state.gpa.findIndex(
          (item) => item.ID === action.payload[0].ID
        );

        if (index !== -1) {
          state.gpa[index] = action.payload[0];
        }
      })
      .addCase(updateGPA.rejected, (state, action) => {
        state.error = action.payload;
      })

      // Delete Question Type
      .addCase(deleteGPA.pending, (state) => {
        state.error = null;
      })
      .addCase(deleteGPA.fulfilled, (state, action) => {
        const deletedIds = action.payload.map((item) => item.ID);

        // Filter out the deleted items
        state.gpa = state.gpa.filter(
          (item) => !deletedIds.includes(item.ID)
        );

      })
      .addCase(deleteGPA.rejected, (state, action) => {
        state.error = action.payload;
      })

      // Active Deactive Question Type
      .addCase(activateDeactivateGPA.pending, (state) => {
        state.error = null;
      })
      .addCase(activateDeactivateGPA.fulfilled, (state, action) => {
        if (action.payload) {
          const updatedGPA = action.payload[0];

          state.gpa = state.gpa.map((item) => item.ID === updatedGPA.ID ? {...item, IsActive: updatedGPA.IsActive} : item)
        }
      })
      .addCase(activateDeactivateGPA.rejected, (state, action) => {
        state.error = action.payload;
      })
    },
});

export default GPASlice.reducer;
